var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2a2 2 0 0 1 4 0h4a1 1 0 1 1 0 1.99H1a1 1 0 1 1 0-2h4zM2 13.5V6h2v7.5c0 .28.22.5.5.5H6V6h2v8h1.5a.5.5 0 0 0 .5-.5V6h2v7.5A2.5 2.5 0 0 1 9.5 16h-5A2.5 2.5 0 0 1 2 13.5z"
  })));
};
export default SvgTrash;